export const questionnaireEvaluationGetEvalIdByExternalEvalIdSuccessReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { evaluationDocId: action.payload });
};
//# sourceMappingURL=questionnaireEvaluationGetEvalIdByExternalEvalIdSuccessReducer.js.map